export const NAV = {
  brand: "nav-brand-link",
  home: "nav-link-home",
  about: "nav-link-about",
  services: "nav-link-services",
  pmoTool: "nav-link-pmo-tool",
  vendor: "nav-link-vendor",
  appRat: "nav-link-app-rationalization",
  staffing: "nav-link-staffing",
  insights: "nav-link-insights",
  contact: "nav-link-contact",
  ctaConsult: "nav-cta-book-consult",
  mobileToggle: "nav-mobile-menu-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  eyebrow: "hero-eyebrow",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaConsult: "hero-cta-book-consult",
  ctaServices: "hero-cta-explore-services",
  marquee: "hero-trust-marquee",
};

export const SERVICES = {
  section: "services-section",
  card: (slug) => `service-card-${slug}`,
  cardCta: (slug) => `service-card-cta-${slug}`,
};

export const WHY = {
  section: "why-pmonexa-section",
  pillar: (slug) => `why-pillar-${slug}`,
};

export const INDUSTRIES = {
  section: "industries-section",
  row: (slug) => `industry-row-${slug}`,
};

export const PMOTOOL = {
  section: "pmo-tool-section",
  feature: (slug) => `pmo-tool-feature-${slug}`,
};

export const STATS = {
  section: "stats-section",
  stat: (slug) => `stat-${slug}`,
};

export const VISION = {
  section: "vision-section",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputCompany: "contact-input-company",
  inputPhone: "contact-input-phone",
  inputService: "contact-input-service",
  inputMessage: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
  error: "contact-error-message",
};

export const FOOTER = {
  section: "footer-section",
  email: "footer-email",
  phone: "footer-phone",
};
